import React from "react";

const EventMetaIcon = ({
  src,
  alt = "",
  className = "h-[22px] w-[22px]",
  imageClassName = "",
  decorative = false,
}) => {
  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center overflow-visible ${className}`}
      aria-hidden={decorative ? true : undefined}
    >
      <img
        src={src}
        alt={decorative ? "" : alt}
        aria-hidden={decorative ? true : undefined}
        className={`block h-full w-full object-contain ${imageClassName}`}
      />
    </span>
  );
};

export default EventMetaIcon;
